export const isQueryRow = row => row.kind === 'example_query';

export const AGGREGATION_FUNCTIONS = {
  anyPending: {
    apply: ({ values }) => values.some(Boolean),
    label: ''
  }
};

export const aggregationPosition = groupNode => (groupNode.depth === -1 ? null : 'inline');

export const STATUS_COLUMN = {
  field: 'pending',
  headerName: 'Status',
  width: 130,
  sortable: false,
  renderCell: params => {
    if (params.rowNode?.type === 'group' && !params.aggregation) {
      return null;
    }
    return params.value ? 'Pending' : 'Deployed';
  }
};

export const SCHEMA_COLUMNS = [
  { field: 'tableName', headerName: 'Table', width: 240 },
  { field: 'kind', headerName: 'Kind', width: 130 },
  { field: 'columnName', headerName: 'Column', width: 200 },
  { field: 'description', headerName: 'Description', flex: 1, minWidth: 220 },
  { field: 'text', headerName: 'Embedded text', flex: 2, minWidth: 320, editable: true },
  STATUS_COLUMN
];

export const QUERY_COLUMNS = [
  { field: 'tableName', headerName: 'Primary table', width: 180 },
  { field: 'question', headerName: 'Question', flex: 1, minWidth: 280, editable: true },
  { field: 'sql', headerName: 'SQL', flex: 2, minWidth: 360, editable: true },
  STATUS_COLUMN
];

export const SCHEMA_GRID_INITIAL_STATE = {
  rowGrouping: { model: ['tableName'] },
  aggregation: { model: { pending: 'anyPending' } }
};
